import React from 'react';
import { Box } from "@mui/material";

function EmojiBullet(props)
{
    const MAX_TITLE_LENGTH_LARGE = 110;
    const MAX_TITLE_LENGTH_SMALL = 40;

    function kisaBaslik(baslik)
    {
        const windowWidth = window.innerWidth;

        const maksimumKarakter =
            windowWidth >= 1000 ? MAX_TITLE_LENGTH_LARGE : MAX_TITLE_LENGTH_SMALL;

        if (baslik.length <= maksimumKarakter)
        {
            return baslik;
        }

        let kisalmisBaslik = baslik.slice(0, maksimumKarakter);

        const sonKelimeOncesiBosluk = kisalmisBaslik.lastIndexOf(" ");

        if (sonKelimeOncesiBosluk !== -1)
        {
            kisalmisBaslik = kisalmisBaslik.slice(0, sonKelimeOncesiBosluk);
        }

        return kisalmisBaslik;
    }

    const { emoji, text } = props;

    const kisaltilmisText = kisaBaslik(text);
    const kalanKisim = text.slice(kisaltilmisText.length);

    return (
        <Box component={'li'} fontSize={'1rem'} lineHeight={1.5} style={{ cursor: 'default' }}>
            <Box component={'span'} aria-label="cheese"
                role="img"
                fontSize={'1.5rem'}>{emoji}</Box>
            <span>
                {kisaltilmisText}
                <br />
                {kalanKisim}
            </span>
        </Box>
    );
}

export default EmojiBullet;
